import { type HTMLAttributes } from "react";
import styled from "styled-components";

const Root = styled.div`
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  /* 프레임 내부 로컬 스태킹 — media/overlay 위로만 올린다(전역 오버레이 밴드 아님). */
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export type MediaFrameActionsProps = HTMLAttributes<HTMLDivElement>;

/**
 * media 프레임 우상단에 떠 있는 인터랙티브 액션 클러스터(전체화면·zoom reset 등).
 * `position: relative` 미디어 박스 — 또는 ZoomPan viewport처럼 transform 밖 레이어 — 안에
 * mount한다. row가 오른쪽 끝에 고정되므로 앞(왼쪽) 액션이 나타나고 사라져도 뒤(오른쪽)
 * 액션의 위치는 안정적이다.
 *
 * 컨테이너가 pointerdown/click/dblclick 전파를 끊는다 — 액션 조작이 아래 미디어의
 * 제스처(Ctrl+drag pan 시작, dblclick 전체화면 토글, click 선택)로 새지 않게 하는 계약.
 * `VideoFrame.actions`/`ZoomPanWrapper.actions`가 내부에서 사용하고, video family 밖
 * 미디어 박스(camera canvas 등)는 직접 mount한다.
 */
export function MediaFrameActions({
  children,
  onPointerDown,
  onClick,
  onDoubleClick,
  ...rest
}: MediaFrameActionsProps) {
  return (
    <Root
      {...rest}
      onPointerDown={(event) => {
        onPointerDown?.(event);
        event.stopPropagation();
      }}
      onClick={(event) => {
        onClick?.(event);
        event.stopPropagation();
      }}
      onDoubleClick={(event) => {
        onDoubleClick?.(event);
        event.stopPropagation();
      }}
    >
      {children}
    </Root>
  );
}

MediaFrameActions.displayName = "MediaFrameActions";
